import React, { createContext, useContext, useEffect, useState } from "react";
import { API_BASE } from "../config/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);     // { uid, nombre, apellido, correo, usuario, rid, gid, area }
  const [loading, setLoading] = useState(true);

  async function fetchMe() {
    try {
      const res = await fetch(`${API_BASE}/api/admin/me`, {
        method: "GET",
        credentials: "include",
      });

      if (!res.ok) {
        setAdmin(null);
        return;
      }

      const data = await res.json();
      setAdmin(data.data || null);
    } catch (e) {
      setAdmin(null);
    }
  }

  async function logout() {
    await fetch(`${API_BASE}/api/admin/logout`, {
      method: "POST",
      credentials: "include",
    });
    setAdmin(null);
  }

  useEffect(() => {
    (async () => {
      await fetchMe();
      setLoading(false);
    })();
  }, []);

  return (
    <AdminAuthContext.Provider value={{ admin, loading, fetchMe, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}